#import "../../../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql"
#import "../../../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql"

fragment AccountsForLeadFragment on Lead {
    id
    accounts(first: 100) {
        primaryEdge {
            node {
                ...AccountForCoreEntityFragment
            }
        }
        edges {
            node {
                ...AccountForCoreEntityFragment
            }
            leadAccountContacts {
                ...ContactForCoreEntityFragment
            }
        }
    }
}
